// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import CollectingSiteSelectionForm from 'components/organisms/CollectingSiteSelectionForm';
import CollectRouteTemplate from 'components/templates/CollectRouteTemplate';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Path } from 'routes';

const CollectSiteSelection = () => {
  const { t } = useTranslation();
  const { routeId } = useParams<{ routeId?: string }>();

  return (
    <CollectRouteTemplate
      h1={t('collect_site_selection.title')}
      prev={routeId !== 'all' ? Path.routeList : undefined}
      showOnlySavedSelectedSiteOnMap
      checkNoneRouteId
    >
      <CollectingSiteSelectionForm />
    </CollectRouteTemplate>
  );
};

export default CollectSiteSelection;
